import {
  FULL_SERVICE,
  GLOBAL_CATALOGS,
} from '../../types';

const initialState = {
  // 勞工安全衛生管理導航欄
  navigations: [], 
  
  isLoading: false,
  // 勞安首頁 start
  board: {
    value: '',
    content: {
      title: '',
      list: [],
      total: 0,
      page: 1,
      rowsPerPage: 10,
      pages: 10,
    },
  },
  // 勞安首頁 end

  policy: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  news: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  test: {
    value: '',
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  faqs: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const cateringReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SERVICE.Labor.Value: {
      return {
        ...state,
        board: { 
          ...state?.board,
          value: action.payload
        }
      };
    }
    case FULL_SERVICE.Labor.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_SERVICE.Labor.List: {
      return {
        ...state,
        board: { 
          ...state?.board,
          content: action.payload
        }
      };
    }
    case FULL_SERVICE.Labor.Test.Value: {
      return {
        ...state,
        test: { 
          ...state?.test,
          value: action.payload
        }
      };
    }
    // case FULL_SERVICE.Labor.Test.Loading: {
    //   return {
    //     ...state,
    //   };
    // }
    case GLOBAL_CATALOGS.Labor.Policy.Report: {
      return {
        ...state,
        policy: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Labor.News.List: {
      return {
        ...state,
        news: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Labor.Test.Report: {
      return {
        ...state,
        test: { ...state?.test, ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Labor.FAQS.List: {
      return {
        ...state,
        faqs: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Lauan.Root: {
      return {
        ...state,
        navigations: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default cateringReducer;
